<app-section-container>
    <app-card-filtro [Title]="'Feed de Novidades'" [ContainButtons]="false" [ContainButtonExtra]="true">
        <!-- <app-button *ngIf="!editarOuCriarNovidade" bgColor="primary" [Icon]="'tune'" [disabled]="false" variant="small"
            hoverEffect="transparent" (onClick)="criarNovo()">
            {{'Cadastrar nova news' | translate}}
        </app-button> -->
    </app-card-filtro>

    <app-card-generic *ngIf="dadosProntos" [width]="'full'" [height]="'auto'" [Barra]="false">
        <div class="flex-column u-gap-16">
            <div class="flex box-info-new u-gap-10 w-full u-text-black-text">
                <p *ngFor="let categoria of categorias"
                    style="padding: 0px; margin: 0px; display: flex; gap: 5px; align-items: center; font-size: 12px;">
                    <i class="far fa-check-circle"></i>
                    {{novidadeSistema?.novidadeCategoriaId == categoria.id ? categoria.descricao : "dd"}}
                </p>
                <p style="padding: 0px; margin: 0px; display: flex; gap: 5px; align-items: center; font-size: 12px;">
                    <i class="far fa-calendar-alt"></i>
                    {{novidadeSistema?.dataCadastro | date: 'dd/MM/yyyy HH:mm':'-0300' }}
                    |<i class="far fa-clock"></i>
                    {{ novidadeSistema?.dataCadastro | date: 'dd/MM/yyyy HH:mm':'-0300' }}
                </p>
            </div>

            <img class="w-75-percent image-article u-mt-20 h-auto radius-small" [src]="novidadeSistema?.imagem" alt="">

            <h1 class="u-fs-20 u-mt-20 u-text-secondary">
                {{novidadeSistema?.titulo}}
            </h1>
            <p class="u-fs-15 u-text-black-text">
                {{novidadeSistema?.descricao}}
            </p>

            <span (click)="voltarFeed()" style="cursor: pointer;" class="flex-start u-gap-5 u-text-primary ">
                <i class="material-symbols-outlined u-text-primary  u-fs-10">arrow_left_alt</i>
                {{'COMMON.BACK' | translate}}
            </span>
        </div>
    </app-card-generic>

    <app-skeleton-card-generic [Altura]="'500'" *ngIf="!dadosProntos"></app-skeleton-card-generic>
</app-section-container>